import _ from "lodash";

export type SortingCriteria = {
    sortFn: Array<(arg0: any) => any>;
    ordering: Array<string>;
};

// returns the sorting criteria for store lists (old and new ones)
// priority can actually only be values between 1-4 but as these are merged with storelists
// from the personallist service (which don't have that field) we just set them to 5 so they appear last
export const sortingCriteriaStoreLists: SortingCriteria = {
    sortFn: [storeList => _.get(storeList, "priority", 5), storeList => _.lowerCase(_.get(storeList, "name", ""))],
    ordering: ["asc", "asc"]
};
